import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import propTypeClassName from '../propTypeClassName';

var SelectOption = function (_PureComponent) {
  _inherits(SelectOption, _PureComponent);

  function SelectOption() {
    _classCallCheck(this, SelectOption);

    return _possibleConstructorReturn(this, (SelectOption.__proto__ || _Object$getPrototypeOf(SelectOption)).apply(this, arguments));
  }

  _createClass(SelectOption, [{
    key: 'render',
    value: function render() {
      return React.createElement('div', null);
    }
  }]);

  return SelectOption;
}(PureComponent);

SelectOption.propTypes = {
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   */
  className: propTypeClassName,
  /** The value of the control. If null and typeof props.children === 'string', children will be used as value */
  value: PropTypes.string,
  /** Label to display in select instead of children. Required if children is not string */
  label: PropTypes.string,
  /** If children is not string, props.label will be used to display selected value in select input */
  children: PropTypes.node
};
export default SelectOption;